import type { ID } from '@octopus-do/octopus-project-core'
import { Files } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { SidebarLink } from '../SidebarLink'

interface Props {
  id: ID
}

export const TemplatesLink: React.FC<Props> = ({ id }) => (
  <SidebarLink
    to={`/dashboard/${id}/templates`}
    label="Templates"
    icon={Files}
  />
)
